import { defineStore } from 'pinia'

// 英文停用词（可扩展）
const STOPWORDS = new Set<string>([
  'and', 'or', 'the', 'a', 'an', 'to', 'for', 'in', 'on', 'of', 'by', 'with', 'from', 'at', 'be'
])

// 仅保留英文、数字与常用中文字符（统一码范围）
const sanitizeToken = (token: string): string => {
  return token.replace(/[^A-Za-z0-9\u4e00-\u9fff]/g, '')
}

const isAlphabetic = (s: string): boolean => /^[A-Za-z]+$/.test(s)
const hasChinese = (s: string): boolean => /[\u4e00-\u9fff]/.test(s)

export const useHighlightStore = defineStore('highlight', {
  state: () => ({
    terms: [] as string[],
    // 从 localStorage 初始化高亮开关，记住用户选择
    enabled: (typeof localStorage !== 'undefined' && localStorage.getItem('highlight_enabled') === '1')
  }),
  actions: {
    setEnabled(val: boolean): void {
      this.enabled = !!val
      // 持久化用户选择
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('highlight_enabled', this.enabled ? '1' : '0')
      }
    },
    toggleEnabled(): void {
      this.enabled = !this.enabled
      // 持久化用户选择
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('highlight_enabled', this.enabled ? '1' : '0')
      }
    },
    updateFromKeyword(keyword: string): void {
      const rawTokens = (keyword || '')
        .split(/\s+/)
        .map(s => s.trim())
        .filter(Boolean)

      const cleaned = rawTokens
        .map(s => sanitizeToken(s.toLowerCase()))

      const dedup = Array.from(new Set(cleaned))
        .filter(t => {
          if (!t) return false
          // 英文词：长度必须 >=3，且不在停用词中
          if (isAlphabetic(t)) {
            return t.length >= 3 && !STOPWORDS.has(t)
          }
          // 中文或混合词：放宽长度限制为 >=2（避免中文两个字被误排除）
          if (hasChinese(t)) {
            return t.length >= 2
          }
          // 其他（数字/符号混合）默认按 >=3 过滤
          return t.length >= 3
        })

      this.terms = dedup
    },
    clear(): void {
      this.terms = []
    }
  }
})